var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeatPrescriptionRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 228,
    rx: 35,
    fill: "#00B8E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 52V86.6154C64 95.1121 70.8879 102 79.3846 102C87.8813 102 94.7692 95.1121 94.7692 86.6154V63.5385C94.7692 59.2901 91.3252 55.8462 87.0769 55.8462C82.8286 55.8462 79.3846 59.2901 79.3846 63.5385V90.4615M106.308 55.8462H156.308C160.556 55.8462 164 59.2901 164 63.5385V155.846C164 160.095 160.556 163.538 156.308 163.538H79.3846C75.1363 163.538 71.6923 160.095 71.6923 155.846V113.538M144.769 86.6154H114M144.769 109.692H114M144.769 132.769H90.9231",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatPrescriptionRequests);
export default __webpack_public_path__ + "static/media/RepeatPrescriptionRequests.8c1a3dcdc9e9fef3fadbc686f4f2740a.svg";
export { ForwardRef as ReactComponent };